import React from "react";
import TabbedPage from "../shared/TabbedPage";
import translate from "../../../../i18n/translate";
import ToppinexSettings from "../ToppinexSettings";
import HotLocalSettings from "../HotLocalSettings";
import EPRSSettingsContainer from "../EPRSSettingsContainer";
import AzySettings from "components/pages/settings/IsrealCompanies/Companies/Azy";

// The gateways every topup goes through. Which operator uses which is set on
// the Operators page; this page holds the logins and product syncs.
const ProvidersPage = ({ defaultTab }) => (
  <TabbedPage
    id="providers"
    title={translate("Providers")}
    intro={translate("providersHint")}
    defaultTab={defaultTab}
    tabs={[
      { key: "toppinex", label: "Toppinex", render: () => <ToppinexSettings /> },
      { key: "eprs", label: "EPRS", render: () => <EPRSSettingsContainer /> },
      { key: "azy", label: "Azy", render: () => <AzySettings /> },
      { key: "hot", label: "Hot", render: () => <HotLocalSettings /> },
    ]}
  />
);

export default ProvidersPage;
